import {Component, OnDestroy, OnInit} from '@angular/core';
import {FeedbackPopupData} from '../../../feedback/FeedbackPopupData';
import {InsightPopupService} from '../insight-popup.service';
import {FeedbackPopupService} from '../../../feedback/feedback-popup.service';
import {distinctUntilChanged, Subscription} from 'rxjs';
import {filter, map} from 'rxjs/operators';

@Component({
    selector: 'mm-feedback-insight-popup',
    templateUrl: './feedback-insight-popup.component.html',
    styleUrl: './feedback-insight-popup.component.scss',
    standalone: false
})
export class FeedbackInsightPopupComponent implements OnInit, OnDestroy {

    public feedbackData$ = this.insightPopupService.selectedLearningPackageId$.pipe(
        filter(id => id !== undefined),
        map(id => new FeedbackPopupData(id)),
        distinctUntilChanged()
    );

    private newFeedbackData$ = new Subscription();

    constructor(public insightPopupService: InsightPopupService,
                private feedbackPopupService: FeedbackPopupService) {
    }

    public ngOnInit(): void {
        this.newFeedbackData$ = this.feedbackPopupService.newFeedbackData$
            .pipe(filter(data => data !== undefined))
            .subscribe(data => this.insightPopupService.cacheFeedbackDraft(data));
    }

    public ngOnDestroy(): void {
        this.newFeedbackData$.unsubscribe();
    }
}
